import React from 'react';
import IconButton from 'material-ui/IconButton';
import NavPrevIcon from 'material-ui/svg-icons/image/navigate-before';
import NavNextIcon from 'material-ui/svg-icons/image/navigate-next';
import './style.scss';

const PaginationBtns = props => {
  const { pagination, totalItems, goToPage, currentPage } = props;
  const lastOfSet = currentPage * pagination;
  const firstOfSet = lastOfSet - (pagination - 1);
  return (
    <React.Fragment>
      <div className={'pagination-btns ' + props.className}>
        <div className="margin-right-15 pagination-count">
          {firstOfSet} - {lastOfSet > totalItems ? totalItems : lastOfSet}
          &nbsp; of&nbsp;
          {totalItems}
        </div>
        <IconButton
          className="btn-rounded-circle margin-right-5"
          size="sm"
          tooltip={'Previous'}
          disabled={currentPage === 1}
          onClick={() => goToPage(currentPage - 1)}
        >
          <NavPrevIcon className="pagination-btn" />
        </IconButton>
        <IconButton
          className="btn-rounded-circle"
          size="sm"
          tooltip={'Next'}
          tooltipPosition="bottom-right"
          disabled={lastOfSet >= totalItems ? true : false}
          onClick={() => goToPage(currentPage + 1)}
        >
          <NavNextIcon className="pagination-btn" />
        </IconButton>
      </div>
    </React.Fragment>
  );
};

export default PaginationBtns;



// WEBPACK FOOTER //
// ./src/components/PaginationBtns/index.jsx